import { FrequencyType } from './schedules.types';
import { MixedSchedule, RawSchedule } from './mixed-schedule.types';

export abstract class ScheduleModalFacade {
  public abstract activeSchedule: MixedSchedule;
  public abstract frequencyType: FrequencyType;
  public abstract hasUpdate: boolean;
  public abstract schedules: MixedSchedule[];

  public abstract setFrequencyType(newFrequency: FrequencyType): void;

  public abstract loadRawSchedules(rawSchedules: RawSchedule[]): void;

  public abstract setActiveSchedule(rawSchedule: RawSchedule): void;

  public abstract onFrequencyChange({
    rawSchedule,
    newFrequency,
  }: {
    rawSchedule: RawSchedule;
    newFrequency: FrequencyType;
  }): void;

  public abstract onScheduleNameChange(name: string): void;

  public abstract startTimeChanged(minute: number): void;

  public abstract scheduleChanged(rawSchedule: RawSchedule): void;

  public abstract setSlackChannel(channel: any): void;

  public abstract backClicked(): void;
}
